import { format } from 'date-fns'
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz'

// Must match CustomerCallbackService on the API.
export const AGENT_TIMEZONE = 'America/Los_Angeles'
export const AGENT_START_HOUR = 8
export const AGENT_END_HOUR = 20
export const SYSTEM_TIMEZONE = 'America/Phoenix'

// The pickers return browser-local Dates; only their wall-clock parts are meaningful, read in `timezone`.
export const toCallbackUtc = (date, time, timezone) =>
  zonedTimeToUtc(
    `${format(date, 'yyyy-MM-dd')}T${format(time, 'HH:mm')}:00`,
    timezone
  )

export const isWithinAgentHours = (date, time, timezone) => {
  const agentHour = Number(
    formatInTimeZone(toCallbackUtc(date, time, timezone), AGENT_TIMEZONE, 'H')
  )
  return agentHour >= AGENT_START_HOUR && agentHour < AGENT_END_HOUR
}

export const isSelectableCallbackTime = (
  date,
  time,
  timezone,
  now = new Date()
) =>
  isWithinAgentHours(date, time, timezone) &&
  toCallbackUtc(date, time, timezone) > now

export const formatCurrentTimeIn = (timezone, now = new Date()) =>
  formatInTimeZone(now, timezone, 'h:mm a')

// What the agent reads back to the customer, plus the same moment on the system (Arizona) clock.
export const formatCallbackReadBack = (date, time, timezone) => {
  const callbackUtc = toCallbackUtc(date, time, timezone)
  return {
    customer: formatInTimeZone(callbackUtc, timezone, "EEE, MMM d 'at' h:mm a"),
    system: formatInTimeZone(callbackUtc, SYSTEM_TIMEZONE, 'EEE, MMM d h:mm a'),
  }
}

export const DEFAULT_MAX_DAYS_AHEAD = 7

// The clock the API validates against: the spoofed date when one is set (non-production only, same gate
// as useRequest), else real time. The API reads the zone-less spoof string in its app zone, Arizona.
export const callbackClockNow = (simulatedDate) => {
  if (process.env.REACT_APP_ENVIRONMENT === 'production' || !simulatedDate) {
    return new Date()
  }
  return zonedTimeToUtc(simulatedDate.replace(' ', 'T'), SYSTEM_TIMEZONE)
}

// The customer's calendar date `daysAhead` days from now, as a browser-local Date for the picker.
export const customerCalendarDate = (
  timezone,
  daysAhead = 0,
  now = new Date()
) => {
  const [year, month, day] = formatInTimeZone(now, timezone, 'yyyy-MM-dd')
    .split('-')
    .map(Number)
  return new Date(year, month - 1, day + daysAhead)
}
